<div class="app-container">
  @if (showLoader()) {
  <app-loader
    [duration]="5000"
    [statusText]="'LOADER.IN_PROGRESS' | translate"
    (completed)="onLoaderComplete()"
  >
  </app-loader>
  }

  <main class="main-content">
    <router-outlet></router-outlet>
  </main>

  @if (!isLogin()) {
  <section class="section-footer">
    <lib-footer
      class="footer"
      [variant]="isLogin() ? 'default':'login'"
      [customCopyright]="'LAYOUT.FOOTER_COPYRIGHT' | translate"
      [status]="isLogin() ? ('LAYOUT.CONN_OK' | translate) : undefined"
      [isConnectedFlag]="isLogin() ? true : undefined"
      [displayTenant]="false"
    >
    </lib-footer>
  </section>
  }
</div>
